module.exports = __webpack_public_path__ + "static/media/preferences.6a5d7580.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/App/account/assets/images/preferences.jpg
// module id = 1258
// module chunks = 2